export const CATEGORIES_DATA = [
  {
    filterImg: '/local/templates/new_site_v2/images/parthners_map/categories/fishing.svg',
    cardImg: '/local/templates/new_site_v2/images/parthners_map/categories/fishing-card.svg',
    code: 'is_fishing',
    name: 'Fishing',
    useInFilter: true,
    showInCard: true,
  },
  {
    filterImg: '/local/templates/new_site_v2/images/parthners_map/categories/offroad.svg',
    cardImg: '/local/templates/new_site_v2/images/parthners_map/categories/offroad-card.svg',
    code: 'is_offroad',
    name: 'Offroad',
    useInFilter: true,
    showInCard: true,
  },
  {
    filterImg: '/local/templates/new_site_v2/images/parthners_map/categories/snowmobile.svg',
    cardImg: '/local/templates/new_site_v2/images/parthners_map/categories/snowmobile-card.svg',
    code: 'is_snowmobile',
    name: 'Snowmobile',
    useInFilter: true,
    showInCard: true,
  },
]

export const SHOP_TYPES_DATA = [
  {
    filterImg: '/local/templates/new_site_v2/images/parthners_map/types/online.svg',
    cardImg: '/local/templates/new_site_v2/images/parthners_map/types/online-card.svg',
    code: 'is_online',
    name: 'Online',
    useInFilter: true,
    showInCard: true,
  },
  {
    filterImg: '/local/templates/new_site_v2/images/parthners_map/types/warehouse.svg',
    cardImg: '/local/templates/new_site_v2/images/parthners_map/types/warehouse-card.svg',
    code: 'is_warehouse',
    name: 'Warehouse',
    useInFilter: true,
    showInCard: true,
  },
]

export const SMALL_POINTS = {
  black: '/local/templates/new_site_v2/images/parthners_map/points/small-black.svg',
  red: '/local/templates/new_site_v2/images/parthners_map/points/small-red.svg',
  blue: '/local/templates/new_site_v2/images/parthners_map/points/small-blue.svg',
}

export const DEFAULT_POINT_IMG = {
  small: SMALL_POINTS.red,
  inactive: '/local/templates/new_site_v2/images/parthners_map/points/online.svg',
  active: '/local/templates/new_site_v2/images/parthners_map/points/online-active.svg',
}

export const POINT_IMAGES = [
  {
    filter: {
      is_warehouse: true,
    },
    small: SMALL_POINTS.red,
    inactive: '/local/templates/new_site_v2/images/parthners_map/points/warehouse.svg',
    active: '/local/templates/new_site_v2/images/parthners_map/points/warehouse-active.svg'
  },
  {
    filter: {
      is_offroad: true,
    },
    small: SMALL_POINTS.black,
    inactive: '/local/templates/new_site_v2/images/parthners_map/points/offroad.svg',
    active: '/local/templates/new_site_v2/images/parthners_map/points/offroad-active.svg'
  },
  {
    filter: {
      is_snowmobile: true,
    },
    small: SMALL_POINTS.black,
    inactive: '/local/templates/new_site_v2/images/parthners_map/points/snowmobile.svg',
    active: '/local/templates/new_site_v2/images/parthners_map/points/snowmobile-active.svg'
  },
  {
    filter: {
      is_fishing: true,
    },
    small: SMALL_POINTS.blue,
    inactive: '/local/templates/new_site_v2/images/parthners_map/points/fishing.svg',
    active: '/local/templates/new_site_v2/images/parthners_map/points/fishing-active.svg'
  },
  {
    filter: {
      is_offroad: true,
      is_snowmobile: true,
    },
    small: SMALL_POINTS.black,
    inactive: '/local/templates/new_site_v2/images/parthners_map/points/snowmobile-offroad.svg',
    active: '/local/templates/new_site_v2/images/parthners_map/points/snowmobile-offroad-active.svg'
  },
  {
    filter: {
      is_fishing: true,
      is_snowmobile: true,
    },
    small: SMALL_POINTS.black,
    inactive: '/local/templates/new_site_v2/images/parthners_map/points/snowmobile-fishing.svg',
    active: '/local/templates/new_site_v2/images/parthners_map/points/snowmobile-fishing-active.svg'
  },
  {
    filter: {
      is_fishing: true,
      is_offroad: true,
    },
    small: SMALL_POINTS.blue,
    inactive: '/local/templates/new_site_v2/images/parthners_map/points/fishing-offroad.svg',
    active: '/local/templates/new_site_v2/images/parthners_map/points/fishing-offroad-active.svg'
  },
  {
    filter: {
      is_fishing: true,
      is_offroad: true,
      is_snowmobile: true,
    },
    small: SMALL_POINTS.black,
    inactive: '/local/templates/new_site_v2/images/parthners_map/points/trio.svg',
    active: '/local/templates/new_site_v2/images/parthners_map/points/trio-active.svg'
  }
]
